import {
  multi,
  number,
  option,
  single,
  text,
  type UsFieldDef,
} from "../us-fields";

export const biliaryFindings = (otherLabel: string): readonly UsFieldDef[] => [
  single(
    "biliary.gallstones",
    "Gallstones/sludge",
    [
      option("absent", "absent"),
      option("present", "present", {
        reveals: [
          multi("biliary.gallstone_location", "Gallstone/sludge location", [
            option("neck", "neck"),
            option("body", "body"),
            option("fundus", "fundus"),
          ]),
        ],
      }),
    ],
    { normal: "absent" },
  ),
  single(
    "biliary.wall_thickening",
    "Gallbladder wall thickening",
    [option("no", "No"), option("yes", "Yes")],
    { normal: "no" },
  ),
  number("biliary.wall_size", "Gallbladder wall size", "mm"),
  single(
    "biliary.pericholecystic_fluid",
    "Pericholecystic fluid",
    [
      option("absent", "Absent"),
      option("present", "Present"),
      option("indeterminate", "Indeterminate"),
    ],
    { normal: "absent" },
  ),
  single(
    "biliary.murphys_sign",
    "Sonographic murphy’s sign",
    [
      option("absent", "absent"),
      option("present", "Present"),
      option("indeterminate", "indeterminate"),
    ],
    { normal: "absent" },
  ),
  single(
    "biliary.common_bile_duct",
    "Common bile duct",
    [
      option("normal", "Normal"),
      option("dilated", "Dilated"),
      option("not_visualized", "Not visualized"),
    ],
    { normal: "normal" },
  ),
  number("biliary.common_bile_duct_size", "Common bile duct size", "mm"),
  text("biliary.other_findings", otherLabel),
];

export const BILIARY_IMPRESSION = multi("biliary.impression", "Impression", [
  option("normal_biliary", "Normal Biliary POCUS"),
  option("cholelithiasis", "Cholelithiasis"),
  option("cholecystitis", "Cholecystitis"),
  option("dilated_cbd", "Dilated CBD"),
  option("indeterminate", "indeterminate"),
  option("other", "Other findings", { revealsText: true }),
]);
